import * as React from 'react';
import FirstStep from '../FirstStep/FirstStep';
import SecondStep from '../SecondStep/SecondStep';
import StepManager from '../../../components/StepManager';
import { fetchTemplateData } from '../../../../epics/get-template-data';
import { connect } from 'react-redux';
import { useEffect } from 'react';
import { getText } from '../../../../services/text/text-service';
import { resolvePaymentTerm } from '../../../../services/summary-page/car';
import { numberWithSpaces } from '../../../../utils/stringUtils';
import * as moment from 'moment';
import { resolveCoverageName } from '../../../../services/summary-page/healthcare';
import SummaryStep from '../SummaryStep/SummaryStep';
import { resolveChosenPriceKeyText } from '../../../../services/summary-page/common';

interface DispatchToProps {
    fetchTemplateData: Function;
}

interface StateToProps {
    templateData: any;
    calculationData: any;
    calculationOut: any;
    buyingInformationForm: any;
}

const EmployeeHealthcareFlow: React.FC<DispatchToProps & StateToProps> = ({
    fetchTemplateData,
    calculationData,
    calculationOut,
    buyingInformationForm,
    templateData
}) => {
    useEffect(() => {
        fetchTemplateData(3005, 181);
    }, []);

    const prepareSummaryData = () => {
        return [
            {
                header: getText('webshopsweden.common.summaryPage.overview'),
                values: [
                    {
                        key: getText(
                            'webshopsweden.common.summaryPage.overview.policyHolder'
                        ),
                        value: calculationOut.customerName
                    },
                    {
                        key: getText(
                            'webshopsweden.common.summaryPage.overview.paymentType'
                        ),
                        value: resolvePaymentTerm(calculationData.paymentTerm)
                    },
                    {
                        key: getText(
                            'webshopsweden.common.summaryPage.insuranceLevel'
                        ),
                        value: resolveCoverageName(
                            calculationData.coverageOption
                        )
                    },
                    {
                        key: getText('webshopsweden.common.deductible'),
                        value:
                            templateData.workSelfrisk.find(
                                deductible =>
                                    deductible.value ===
                                    calculationData.deductibleCode
                            ).name + ' kr'
                    },
                    {
                        key: getText(
                            'webshopsweden.common.buyingInformation.startDate'
                        ),
                        value: moment(buyingInformationForm.values.startDate)
                            .format('YYYY-MM-DD')
                            .toString()
                    },
                    {
                        key: getText(
                            resolveChosenPriceKeyText(
                                calculationData.paymentTerm
                            )
                        ),
                        value:
                            numberWithSpaces(
                                calculationOut.premiumList[0].premium
                            ) + ' kr'
                    }
                ]
            }
        ];
    };

    return (
        <StepManager>
            <FirstStep
                initialValues={{
                    cpr: window.sessionStorage.getItem('healthCare_cpr')
                }}
            />
            <SecondStep />
            <SummaryStep sectionsProvider={() => prepareSummaryData()} />
        </StepManager>
    );
};

const mapStateToProps = state => ({
    templateData: state.templateData.templateData,
    calculationData: state.calculationData.calculatedData.calculation,
    calculationOut: state.calculationData.calculatedData.calculationOut,
    buyingInformationForm: state.form.buyingInformation
});

export default connect<StateToProps, DispatchToProps>(mapStateToProps, {
    fetchTemplateData
})(EmployeeHealthcareFlow);
